import { AbstractDialogContent } from '@abstracts/dialog/dialog-content';
import { Component, Inject, Injector, OnInit, ViewChild } from '@angular/core';
import { DeleteUserDialogContentComponent } from '@components/dialog/delete-user-dialog/delete-user-dialog-content/delete-user-dialog-content.component';
import { SendInviteRequest } from '@dto/sendInviteRequest';
import { UserEditDto } from '@dto/userEditDto';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AuthenticationService } from '@services/authentication/authentication.service';
import { CustomersService } from '@services/entity/customers.service';
import { UsersService } from '@services/entity/users.service';
import { FormService } from '@services/form/form.service';
import { ToastService } from '@services/toast/toast.service';
import { plainToClass } from 'class-transformer';
import Swal from 'sweetalert2';
import { RfidCardDto } from '../../../../dto/rfidCardDto';
import { UpdateUserRequest } from '../../../../dto/updateUserRequest';

@Component({
  selector: 'app-edit-user-dialog-content',
  templateUrl: './edit-user-dialog-content.component.html',
  styleUrls: ['./edit-user-dialog-content.component.scss']
})
export class EditUserDialogContentComponent extends AbstractDialogContent implements OnInit {

  public className = 'EditUserDialogContentComponent';

  @ViewChild('editUserComponent') editUserComponent;

  public customerId: number;

  public user: UserEditDto;
  public rfidCards: RfidCardDto[];
  public isMasterUser: boolean;
  public isOperator: boolean;
  public isSupporter: boolean = false;

  public formCreated: boolean;

  constructor(
    @Inject('BASE_URL') private baseUrl: string,
    public dialog: NgbModal,
    public activeModal: NgbActiveModal,
    public formService: FormService,
    public toastService: ToastService,
    public authenticationService: AuthenticationService,
    private customersService: CustomersService,
    private usersService: UsersService,
    injector: Injector) {
    super(activeModal, injector);
  }

  onEntityLoadedEvent(user: UserEditDto) {
    this.isOperator = this.authenticationService.userHasRole('Operator')
    this.isSupporter = this.authenticationService.userHasRole('Supporter')
    this.user = user;
    if (this.customerId) {
      this.customersService.checkIfMasterUserOfCustomer(this.customerId, user.id).subscribe(result => {
        this.isMasterUser = result;
        this.formCreated = true;
      })
    } else {
      this.usersService.checkIfMasterUser(user.id).subscribe(result => {
        this.isMasterUser = result;
        this.formCreated = true;
      })
    }
  }

  openDeleteDialog(): void {

    let toastText = (!this.user.email || this.user.email.trim().length === 0) ? 'Der Benutzer wurde gelöscht' : 'Der Benutzer wurde ausgeladen'
    const dialogRef = this.dialog.open(DeleteUserDialogContentComponent, { centered: true, backdrop: 'static' });
    dialogRef.componentInstance.userId = this.user.id;
    dialogRef.componentInstance.user = this.user;

    dialogRef.result.then((result) => {
      if (result.success) {
        //this.toastService.success($localize`:@@EditUserDialogDeleteSuccessHeader:${toastText}`);
        this.activeModal.close();
      } else {
        this.messageService.setError(result.error);
        this.activeModal.close();
      }
    }, (backdrop) => {});
  }


  sendInviteEmail() {
    const sendInviteRequest = this.getSendInviteRequest();

    this.authenticationService.sendInvite(sendInviteRequest).subscribe(result => {
      this.openReInviteSuccessDialog();
    }, error => { });
  }

  getSendInviteRequest(): SendInviteRequest{
    const sendInviteRequest: SendInviteRequest = {
      email: this.user.email,
      firstName: this.user.firstName,
      lastName: this.user.lastName,
      clientURI: this.baseUrl + 'auth/register',
      invitingCustomerId: this.customerId
    }

    return sendInviteRequest;
  }


  openReInviteSuccessDialog() {
    Swal.fire({
      title: $localize`:@@InviteUserSuccessHeader:Die Einladung wurde an den Benutzer erneut versendet!`,
      text: $localize`:@@InviteUserSuccessBody:`,
      icon: 'success',
      confirmButtonText: $localize`:@@DialogOkButton:OK`,
      confirmButtonColor: 'green',
    }).then((result) => {
      if (result.isConfirmed) {
        this.activeModal.close();
      }
    })
  }

  openInviteSuccessDialog() {
    Swal.fire({
      title: $localize`:@@InviteUserSuccessHeader:Die Einladung wurde an den Benutzer versendet!`,
      text: $localize`:@@InviteUserSuccessBody:Sie können dem Benutzer ab sofort RFID-Karten zuweisen und ihn an Ladestationen autorisieren.`,
      icon: 'success',
      confirmButtonText: $localize`:@@DialogOkButton:OK`,
      confirmButtonColor: 'green',
    }).then((result) => {
      if (result.isConfirmed) {
        this.activeModal.close();
      }
    })
  }

  sendInvitation() {
    this.usersService
      .invite(this.user.id, {baseUrl: `${this.baseUrl}auth/register`, customerId: this.user.selectedCustomerId})
      .subscribe((response: any) => {
        this.openReInviteSuccessDialog();
        this.activeModal.close();
      }, error => {
        console.error(error);
        this.toastService.error($localize`:@@EditUserDialogInviteErrorToast:Benutzer konnte nicht eingeladen werden.`)
      }
      )
  }

  onCancelClick() {
    this.formService.unsavedChanges = false;
    this.formService.valuesAtInit = undefined;
    this.activeModal.close();
  }

  getDelButtonText(): string {
    return (!this.user.email || this.user.email.trim().length === 0) ? 'Benutzer löschen' : 'Benutzer ausladen';
  }
}
